 // Email and phone number labels
  document.addEventListener('DOMContentLoaded', () => {
    const handleContactLinks = () => {
      const links = document.querySelectorAll('a[href^="mailto:"], a[href^="tel:"]');
  
      links.forEach(link => {
        const href = link.getAttribute('href');
        let linkText = link.textContent.trim();
  
        if (href.startsWith('mailto:')) {
          link.setAttribute('aria-label', `Email Address: ${linkText}`);
        } else if (href.startsWith('tel:')) {
          // remove tel
          linkText = linkText.replace(/^(Tel:|Phone:)\s*/i, '');
          link.setAttribute('aria-label', `Phone number: ${linkText}`);
        }
      });
    };
  
    handleContactLinks();
  });


//  br tag hide
 $(document).ready(function(){
  $("br").attr("aria-hidden", "true");
});

// Accessibility Enhancements for Third-Party Links
$(document).ready(function () {
  var excludedLinks = []; 

  function isThirdParty(url) {
    try {
      var linkHost = new URL(url, window.location.origin).hostname;
      var currentHost = window.location.hostname;
      return linkHost && linkHost !== currentHost;
    } catch (e) {
      return false;
    }
  }

  function handleExternalLinks() {
    $("a").each(function () {
      var $link = $(this);
      var href = $link.attr("href");

      if (!href || !isThirdParty(href) || excludedLinks.includes(href)) return;

      // Always open in new tab
      $link.attr("target", "_blank");
      $link.attr("rel", "noopener noreferrer");

      // Add aria-label only if missing
      if (!$link.attr("aria-label")) {
        var existingText = $.trim($link.text());
        var ariaLabel = existingText
          ? existingText + ", This link will open in a new tab"
          : "This link will open in a new tab";
        $link.attr("aria-label", ariaLabel);
      }

      // Update image alt only if missing
      var $img = $link.find("img, svg").first();
      if ($img.length && !$img.attr("alt")) {
        $img.attr("alt", "This link will open in a new tab");
      }
    });
  }

  // Run once on load
  handleExternalLinks();

  // Re-run dynamically if DOM changes
  var observer = new MutationObserver(function () {
    handleExternalLinks();
  });
  observer.observe(document.body, { childList: true, subtree: true });
});


// Apply aria-labels to variant inputs and hide labels for accessibility  
$(document).ready(function () {

  function updateVariantAria($scope) {
    $scope = $scope || $(document);

    $scope.find('input[type="radio"], input[type="checkbox"]').each(function () {
      var $input = $(this);
      var id = $input.attr('id');
      if (!id) return;

      var $label = $('label[for="' + id + '"]');
      if (!$label.length) return;

     
      var labelClone = $label.clone();
      labelClone.children().remove();
      var text = $.trim(labelClone.text().replace(/\s+/g, ' '));

      if (text) {
        $input.attr('aria-label', text);
        $label.attr('aria-hidden', 'true');
      }
    });
  }

  updateVariantAria();

  // Mutation observer
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.addedNodes && m.addedNodes.length) {
        $(m.addedNodes).each(function () {
          if ($(this).is('input, label, fieldset, div')) {
            updateVariantAria($(this));
          } else {
            updateVariantAria($(this).find('input, label, fieldset, div'));
          }
        });
      }
      if (m.type === 'attributes' && $(m.target).is('input, label')) {
        updateVariantAria($(m.target));
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['id', 'for']
  });

});


// Specific opt-out link  aria-labelupda 
$(document).ready(function () {
  
  $('a[href="https://www.nahoku.com/pages/data-sharing-opt-out"]').attr(
    "aria-label",
    "Click here Data Sharing Opt-Out"
  );
});

// delete same domain target blank
$(document).ready(function () {
  $('a[target="_blank"]').each(function () {
    let href = $(this).attr('href');
    // check if internal link hai (nahoku.com domain)
    if (href && href.indexOf(window.location.hostname) !== -1) {
      $(this).removeAttr('target');
    }
  });
});

// Move <nav> after .header__icons inside header
$(document).ready(function() {
  $('.header__icons').after($('.header__inline-menu'));
});


  // Target specific link inside footer menu
$(document).ready(function ($) {
  $('.footer-block--menu ul.footer-block__details-content li a[href="/pages/hawaiian-heirloom-jewelry"]')
    .attr('aria-label', 'Hawaiian Heirloom Jewelry collection');
});


  // Mobile filter drawer custom close button custom
 $(document).ready(function () {
    $('.mobile-facets__closemob').on('click', function () {
      var $details = $(this).closest('details.mobile-facets__disclosure');
      $details.removeAttr('open');
      $details.find('summary.mobile-facets__open-wrapper').focus();
    });
  });

 // Check if text is purely numeric (e.g. "45109")
 // Set aria-label using title + item no
  jQuery(document).ready(function ($) {
  $('a').each(function () {
    var $link = $(this);
    var text = $.trim($link.text());
    if (/^\d+$/.test(text)) {
      var title = $link.attr('title');
      if (title) {
       
        var ariaLabel = title + " item no " + text;
        $link.attr('aria-label', ariaLabel);
      }
    }
  });
});


// see full detail accordion link aria-label
$(document).ready(function() {
  $('.accordion__content.rte a').each(function() {
    var linkText = $(this).text().trim();
    var linkTitle = $(this).attr('title') ? $(this).attr('title').trim() : '';
    var ariaLabel = linkTitle
      ? linkText + ', about ' + linkTitle
      : linkText;

    $(this)
      .attr('aria-label', ariaLabel)
      .removeAttr('target');
  });
});
